import React, { useState, Fragment, useEffect } from 'react';
import DataTable from "react-data-table-component";
import { Form } from 'react-bootstrap';
import { FaEye } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { FaEyeSlash } from 'react-icons/fa6';


import Layout from '../../Layout/Layout';
import { getuserslist, setactivateUserAction } from '../../actions/users';
import config from './../../lib/config'
import { toast } from 'react-toastify';

const UsersList = () => {



    const navigate = useNavigate();
    

    const [userList, setUserList] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchText, setSearchText] = useState("");


    useEffect(() => {
        getUserslist1();
      }, [searchText])
    
      const getUserslist1 = async () => {
        var test = await getuserslist({searchText: searchText});
        
        setUserList(test.data);
      }

    const columns = [
        {
            key: "ind",
            name: "S.No",
            // className: "name",   
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>
                <p>
                    {/* {(((pageNumber-1)*limit)+((((pageNumber*limit)>userList?.length))?(index):(index + 1)))} */}
                    {(((pageNumber-1)*limit)+(index + 1))}
                </p>

        },
        {

            key: "UserName",
            name: "User Name",
            // // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <p>
                    {
                    row?.Regname 
                    ? row?.Regname.length>8 ? row?.Regname?.slice(0,5)+'...' : row?.Regname
                    : ""
                    }
                </p>
              ),

        },
        // {
        //     key: "datetime",
        //     name: "Log-In Date And Time",
        //     // className: "Name",
        //     align: "left",
        //     sortable: false,
        //     cell: (row, index, column, id) =>(
        //         <p>{moment(row.Loginat).format('MMMM,Do YYYY, hh:mm A')}</p>
        //       ),

        // },
        {

            key: "User Address",
            name: "Wallet Address",
            // className: "tokenCreator",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <p>
                    {
          row.curraddress?
          row.curraddress.slice(0,5)+"....."+row.curraddress.slice(row.curraddress.length-5,row.curraddress.length)
          :"No Address Added"
        }
                </p>
              ),


        }, {

            key: "EmailId",
            name: "Email Id",
            // className: "tokenOwner",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <p>{row?.Regemail?row?.Regemail:"No Email-Id added"}</p>
              ),


        },
        {

            key: "CustomUrl",
            name: "Custom Url",
            // className: "tokenCategory",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <p>{row?.customurl?row?.customurl:"No Custom Url added"}</p>
              ),

        },
        {

            key: "ProfileImagePreview",
            name: "Profile Image",
            // className: "tokenRoyality",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <div>
                    {
                        row.image !="" 
                        ?<img width="25" height="25" src={`${config.Back_Url}/images/${row.id}/${row.image}`}/>
                        :"No Profile Image added"
                    }
                </div>
              ),

        },
        {

            key: "Cover Image Preview",
            name: "Cover Image",
            // className: "tokenBid",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <div>
                    {
                        row.coverimage !=""
                        ?
                        <img width="25" height="25" src={`${config.Back_Url}/images/coverimages/${row.id}/${row.coverimage}`}/>
                        :
                        "No Cover Image added"
                    }
                </div>
              ),

        },
        {

            key: "Activate / De-Activate",
            name: "Activate / De-Activate",
            // className: "tokenBid",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => {
                return (
                    <Fragment>
                        <button
                            data-toggle="modal"
                            data-target="#update-template-modal"
                            className="btn btn-primary btn-sm"
                            onClick={()=>setactivateUser(row,'activate')}

                            style={{ marginRight: '5px' }}
                        >
                            {
                                row?.activate
                                ?
                                <FaEye />
                                :
                                <FaEyeSlash />
                            }
                            {/* <i className="fa fa-edit"></i> */}
                            {/* <i className="fa fa-eye"></i> */}
                            
                        </button>
                    </Fragment>
                );
            }

        },
        {

            key: "Delete",
            name: "Delete",
            // className: "tokenQuantity",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => {
                return (
                    <Fragment>
                        <button
                            data-toggle="modal"
                            data-target="#update-template-modal"
                            className="btn btn-danger btn-sm"
                              onClick={() => setactivateUser(row,"delete")}

                            style={{ marginRight: '5px' }}
                        >
                            {/* <i className="fa fa-edit"></i> */}
                            {/* <i className="fa fa-eye"></i> */}
                            <RiDeleteBin5Line />
                        </button>
                    </Fragment>
                );
            }

        },

        // {
        //   key: "Hide/show",
        //   text: "Actions",
        //   className: "action",
        //   width: 200,
        //   align: "left",
        //   sortable: false,
        //   cell: record => {
        //       return (
        //       <Fragment>
        //          <input type="checkbox"

        //           // checked={isItemSelected(record.tokenOwnerDb._id)}
        //           // onChange={(e)=>{hideshow(e,record)}}
        //           />
        //        </Fragment>
        //     );
        //   }
        // },
    ];

    async function setactivateUser(user,from) {
        if(user._id){
          let payload = {
            id:user._id,
            checked:!user?.activate,
            from: from,
          }
          var activeUserData = await setactivateUserAction(payload);
          
          if (activeUserData && activeUserData.data && activeUserData.data.success && activeUserData.data.status === true) {
            if(from=='delete'){
              toast.success('User Deleted',1000); 
            }
            else {
              if (payload?.checked) {
                toast.success('User Activated', 1000);
              } 
              else {
                toast.success('User De-Activated', 1000);
              }
            }
            
            await getUserslist1()
          }
        }
      }

      function pageRowChange (page, row) {
        
        setPageNumber(page);
        setLimit(row);
    }

    return (
        <Layout>
            <div className="userslist">
                <h1 className="pagehead">User List</h1>
                <div className="cardbox">
                    <div className="tablebox">
                        <Form.Control type="text" onChange={(e)=>setSearchText(e?.target?.value)} value={searchText} placeholder="name or address or email" />
                        <DataTable
                            className='react-datatables'
                            columns={columns}
                            data={userList}
                            pagination // Enable pagination
                            // paginationPerPage={2} // Rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                            onChangePage={(page,totalRows)=>pageRowChange(page,limit)}
                            onChangeRowsPerPage={(totalRows, page)=>pageRowChange(page,totalRows)}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default UsersList;